module.exports = __webpack_public_path__ + "img/panch_cuento_6_nubes.b0b3f837.png";